import type { CSSProperties } from 'react';

/** Segmented control styles — match ChartsPage range pills (#charts-range-controls). */
export const SEG_TRACK: CSSProperties = {
  display: 'flex',
  background: 'var(--surface-sunken)',
  borderRadius: 12,
  padding: 3,
  boxShadow: 'var(--nm-inset-sm)',
  gap: 2,
};

export const SEG_PILL: CSSProperties = {
  padding: '6px 13px',
  borderRadius: 9,
  fontSize: 12,
  fontWeight: 700,
  color: 'var(--fg-4)',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  transition: 'all 170ms',
  fontFamily: 'var(--font-display)',
};

export const SEG_PILL_ACTIVE: CSSProperties = {
  background: 'var(--surface-0)',
  color: 'var(--fg-1)',
  boxShadow: 'var(--nm-raised-sm)',
};

export const SEG_INPUT: CSSProperties = {
  flex: 1,
  width: '100%',
  minWidth: 0,
  padding: '6px 13px',
  borderRadius: 9,
  border: 'none',
  background: 'var(--surface-0)',
  color: 'var(--fg-1)',
  fontSize: 12,
  fontWeight: 700,
  fontFamily: 'var(--font-display)',
  boxShadow: 'var(--nm-raised-sm)',
  outline: 'none',
  boxSizing: 'border-box',
};
